// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import uuidv4 from 'uuid/v4';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';

import footerWaveDesktop from '../../images/footer-wave-desktop.png';
import footerWaveMobile from '../../images/wave-mobile.png';
import rectangle from '../../images/rectangle.png';
import styles from './styles';

class Footer extends Component {
  static propTypes = {
    classes: PropTypes.object,
    data: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      links: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        link: PropTypes.string,
      })),
    })),
  };

  static defaultProps = {
    classes: {},
    data: [{
      label: 'no section',
      links: [{
        label: 'no link',
        link: '/',
      }],
    }]
  };

  renderSection = (section) => {
    const { classes } = this.props;
    return (
      <div key={uuidv4()} className={classes.footerSection}>
        <h6 className={classes.sectionLabel}>{section.label}</h6>
        {section.links
          .map(el => <Link key={uuidv4()} className={classes.link} to={el.link}>{el.label}</Link>)}
      </div>
    );
  }

  render() {
    const { classes, data } = this.props;

    return (
      <div className={classes.mainContainer}>
        <div className={classes.relativeContainer}>
          <MediaQuery minWidth={500}>
            {matches => (matches
              ? <img className={classes.waveDesktop} src={footerWaveDesktop} alt={'wave'} />
              : <img className={classes.waveMobile} src={footerWaveMobile} alt={'wave'} />)}
          </MediaQuery>
          <MediaQuery minWidth={500}>
            <img className={classes.rectangleDesktop} src={rectangle} alt={'rectangle'} />
          </MediaQuery>
          <footer className={classes.footer}>
            {data.map(section => this.renderSection(section))}
          </footer>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Footer);
